var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{class:{
            'is-invalid': !!_vm.error
        },attrs:{"label":"name","placeholder":"Search...","options":_vm.forms},on:{"search":_vm.onSearch},model:{value:(_vm.selectedForm),callback:function ($$v) {_vm.selectedForm=$$v},expression:"selectedForm"}},[_c('template',{slot:"no-options"},[_vm._v(" Start typing to search for a form ")])],2),_c('div',{staticClass:"invalid-feedback"},[_vm._v(" "+_vm._s(_vm.error)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }